import { useContext, memo, useEffect } from "react";
import { BefMessage, BefMessageControllerServiceContext } from "@beflam/bef-core";
import { Modal } from "./Modal";
import React from "react";

export function modalInner(props: { modal: any }) {
    const message = props.modal;
    return (

        <Modal message={message} />
    );
}

const MemoMdoal = memo(modalInner, (prevProps, nextProps) => prevProps.modal === nextProps.modal);

export function ModalContainer() {
    let messageController = useContext(BefMessageControllerServiceContext);
    let [messages, setMessage] = React.useState<BefMessage[]>(messageController.messages)

    useEffect(() => {
        const messageChangedSub = messageController.messageChanged.subscribe(result => {
            setMessage(result);
        })
        return () => {
            messageChangedSub.unsubscribe();
        };
    }, []);
    return (<>
        {
            messages.map((message: any, index) => {
                return (
                    <MemoMdoal key={index} modal={message}></MemoMdoal>
                )


            })
        }
    </>);
}
